import { render } from "./TopStory.vue?vue&type=template&id=1ea29d16"
import script from "./TopStory.vue?vue&type=script&lang=js"
export * from "./TopStory.vue?vue&type=script&lang=js"
script.render = render

export default script